<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
        &nbsp;
        <value-change-logs-detail
          :valueChangeLogs="valueChangeLogs"
        ></value-change-logs-detail>
      </p>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hcQCQDBaoCaoChangeLogsBuilder from "../../../services/hanhchinh/quychequydinh/hcQCQDBaoCaoChangeLogsBuilder";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import ActionLogTemplate from "../ketluan/action-log-template.vue";
import ValueChangeLogsDetail from "../ketluan/value-change-logs-detail";

export default {
  name: "hc-quychequydinh-bao-cao-action-log",
  components: { ValueChangeLogsDetail, ActionLogTemplate },
  props: ["actionLog"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {
      actionNameLabel: null,
      valueChangeLogs: []
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    hcQCQDBaoCaoChangeLogsBuilder
      .newInstance()
      .build(JSON.parse(this.actionLog.dataJson))
      .then(({ valueChangeLogs }) => (this.valueChangeLogs = valueChangeLogs));
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-bao-cao-action-log.vue